import { observable, makeObservable } from 'mobx'
import { Model } from 'infra/model'
import { Id } from 'types/definitions'
import { SkillTagDTO } from 'iam/dtos/skill-tag'

export default class SkillTag extends Model<SkillTagDTO, SkillTag> {
  @observable id = Id.none
  @observable label = ''
  @observable color = ''
  @observable workspaceId = Id.none

  constructor() {
    super()
    makeObservable(this)
  }

  parse(json: SkillTagDTO): Partial<SkillTag> {
    return {
      id: json.id,
      label: json.label,
      workspaceId: json.workspace_id,
      color: json.color,
    }
  }
}
